import { connect } from 'react-redux';
import SelfAuthorizations from './SelfAuthorizations';
import {
  getCurrentSelection,
  resetSelfAuth,
  setActiveSelfAuthTab,
  setDataList,
  setMobileDrawerOpen,
  setMobileFilterDrawerOpen,
  setSelfAuthorizations,
} from './store/selfAuthorizationsSlice';
import { resetFilters, setFilters } from '../filters/store/filtersSlice';

const mapStateToProps = state => ({
  authorizationSelection: state.loadingManagement.filters.authorizationSelection,
  currentSelection: getCurrentSelection(state),
  dialogOpen: state.loadingManagement.selfAuthorizations.selfAuthorizationDialogOpen,
  extendedLoadingSelection: state.loadingManagement.filters.extendedLoadingSelection,
  selfAuthorizations: state.loadingManagement.selfAuthorizations.selfAuthorizations,
  tempSearchTerm: state.loadingManagement.filters.tempSearchTerm,
});

export default connect(mapStateToProps, {
  resetFilters,
  resetSelfAuth,
  setActiveSelfAuthTab,
  setDataList,
  setFilters,
  setMobileDrawerOpen,
  setMobileFilterDrawerOpen,
  setSelfAuthorizations,
})(SelfAuthorizations);
